class SideDrawer extends HTMLElement {
  constructor() {
    super();

    const thisElement = this

    //Toggle event listeners
    this.addEventListener('drawer-toggle', function () {
      if (this.classList.contains('active')) {
        thisElement.close(this)
      } else {
        thisElement.open(this)
      }
    })

    //Key up and body click events
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.onBodyClick = this.handleBodyClick.bind(this);

    //set drawer height
    this.drawerHeight()

    //add event listener for resize
    window.addEventListener('resize', this.drawerHeight)
  }

  //Open drawer
  open(drawer) {
    this.classList.add('active');
    if (this.getAttribute("data-shade") != "false") {
      document.body.classList.add('has-shade-2x');
    }
    this.addEventListener('transitionend', () => {
      drawer.focus();
      trapFocus(drawer);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick, { passive: true });
  }

  //Close drawer
  close() {
    this.classList.remove('active');
    document.body.classList.remove('has-shade-2x');
    document.body.removeEventListener('click', this.onBodyClick, { passive: true });
    removeTrapFocus(this);
  }

  //Body click event to close drawer
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this && !target.closest('side-drawer') && !target.closest('side-drawer-toggle')) {
      this.close();
    }
  }

  //recalculate height of drawer when viewport changes
  drawerHeight() {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
}

customElements.define('side-drawer', SideDrawer);